import { toast } from "react-toastify";
import { apiSlice } from "../api/apiSlice";

export const salaryHistoryApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSalaryHistories: builder.query({
      query: () => ({
        url: `salaryHistory?status=true&page=1&count=20`,
      }),
      providesTags: ["SalaryHistories"],
    }),

    getSingleSalaryHistory: builder.query({
      query: (id) => ({
        url: `salaryHistory/${id}`,
      }),
      providesTags: ["SalaryHistory"],
    }),

    addSalaryHistory: builder.mutation({
      query: (values) => ({
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `salaryHistory`,
        body: values,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toast.success("Salary History added successfully");
        } catch (err) {
          toast.error("An error occurred while adding Salary History");
        }
      },
      invalidatesTags: ["SalaryHistories", "User"],
    }),

    updateSalaryHistory: builder.mutation({
      query: ({ id, values }) => ({
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `salaryHistory/${id}`,
        body: values,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toast.success("Salary History updated successfully");
        } catch (err) {
          toast.error("An error occurred while updating Salary History");
        }
      },
      invalidatesTags: ["SalaryHistories", "SalaryHistory", "User"],
    }),

    deleteSalaryHistory: builder.mutation({
      query: (id) => ({
        url: `salaryHistory/${id}`,
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toast.success("Deleted Salary History successful");
        } catch (err) {
          toast.error("An error occurred while deleting the Salary History");
        }
      },
      invalidatesTags: ["SalaryHistories", "SalaryHistory", "User"],
    }),
  }),
});

export const {
  useGetSalaryHistoriesQuery,
  useGetSingleSalaryHistoryQuery,
  useAddSalaryHistoryMutation,
  useUpdateSalaryHistoryMutation,
  useDeleteSalaryHistoryMutation,
} = salaryHistoryApi;
